import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "d-flex justify-center flex-column" }
const _hoisted_2 = { key: 0 }

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PrimaryButton',
  props: {
  loading: {
    type: Boolean,
    required: false,
    default: false
  },
  prependIcon: {
    type: String,
    required: false
  },
  appendIcon: {
    type: String,
    required: false
  },
  loadingColor: {
    type: String,
    required: false,
    default: 'white'
  }
},
  setup(__props) {

const props = __props

/* global defineProps */



const shouldIconsDisplay = computed(() => {
  return !props.loading;
});

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_btn, {
      type: "button",
      "min-width": "150",
      "prepend-icon": _unref(shouldIconsDisplay) ? props.prependIcon : '',
      "append-icon": _unref(shouldIconsDisplay) ? props.appendIcon : '',
      color: "primary",
      class: "my-4",
      disabled: props.loading
    }, {
      default: _withCtx(() => [
        (!props.loading)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
              _renderSlot(_ctx.$slots, "default")
            ]))
          : (_openBlock(), _createBlock(_component_v_progress_circular, {
              key: 1,
              size: "small",
              indeterminate: "",
              color: __props.loadingColor
            }, null, 8, ["color"]))
      ]),
      _: 3
    }, 8, ["prepend-icon", "append-icon", "disabled"])
  ]))
}
}

})